<div
  class="w-full flex-wrap ftype my-1 sm:hidden lg:flex lg:pt-5 lg:pb-1 xxl:pb-2"
>
  <div
    class="flex items-center justify-between flex-grow pl-6 flex-wrap h-full"
  >
    <div class="flex items-center justify-center h-full">
      @for (item of subHeaderMenuItem(); track $index) {
        <div
          [routerLink]="item.route"
          routerLinkActive="selected-menu-item"
          #rla="routerLinkActive"
          class="ps-3 cursor-pointer"
          (keydown.enter)="navigate(item.route)"
          (keydown.space)="navigate(item.route)"
        >
          @if (item.label) {
            <div class="flex flex-col items-center align">
              <span
                class="label text-[15px] ml-0 pr-4 font-normal text-white"
                >{{ item.label | translate }}</span
              >
            </div>
          }
        </div>
      }
    </div>

    <div class="pr-1.5">
      <span class="text-xs text-white"
        >System Integrator ID : {{ user.installer_id }}</span
      >
    </div>
  </div>
  <div class="flex w-fit items-center sp pr-8">
    <div>
      <span class="text-xs text-white">
        | &nbsp;Last Updated:
        {{ date | date: "dd/MM/yyyy hh:mm:ss a" }}
      </span>
    </div>
    <div class="hidden items-center gap-1">
      <div>
        <span class="text-xs text-white">{{ "map_view" | translate }}</span>
      </div>

      <div class="mt-1">
        <img src="assets/svg/map.svg" alt="icon" />
      </div>
      <div class="flex h-full mt-[0.124rem]">
        <span class="text-white text-xs">{{ "solar" | translate }}</span>
      </div>
      <div class="mt-[0.128rem]">
        <img src="assets/svg/filter.svg" alt="icon" />
      </div>
    </div>
  </div>
</div>
<div
  class="flex-wrap items-center w-full stype sm:flex px-3 lg:hidden pt-6 sm:text-lg md:pr-6"
>
  <div class="flex hpf justify-between w-full items-center">
    <div class="flex items-center h-full">
      @for (item of subHeaderMenuItem(); track $index) {
        <div
          role="button"
          [routerLink]="item.route"
          routerLinkActive="selected-menu-item"
          #rla="routerLinkActive"
          class="ps-3 cursor-pointer mr-2"
          (keydown.enter)="navigate(item.route)"
          (keydown.space)="navigate(item.route)"

        >
          @if (item.label) {
            <div class="flex flex-col items-center">
              <span class="label text-[15px] ml-0 font-normal text-white">{{
                item.label | translate
              }}</span>
              <div class="indicator w-[25px] rounded-full mt-1.5"></div>
            </div>
          }
        </div>
      }
    </div>
   
  </div>
  <div
    class="w-full flex justify-between items-center p-1 sm:pl-[1.8%] md:pl-[1.3%] pt-2 text-center"
  >
    <div class="h-full flex items-center text-white text-sm">
      <div>System Integrator ID :</div>
      <div class="ml-2 mt-[0.1rem]">{{ user.installer_id }}</div>
    </div>
    <div class="h-full flex items-center text-white text-sm">
      <div>Last Updated :</div>
      <div class="ml-2">{{ date | date: "dd/MM/yyyy hh:mm:ss a" }}</div>
    </div>
  </div>
</div>
